import React from 'react';
import { offRoadSelections, AntiSkidSelections, DSTSelections, Selections, Selections2 } from '../../constants/';
import { Table, Dropdown, Input, Button, Divider } from 'semantic-ui-react';
import { datePicker, MultiDropdown } from './';

function drop() {
    return Selections.map((selection) => (
        <div>
            <label>{selection.label} :</label>
            <Dropdown
                placeholder={selection.placeholder}
                id={selection.id}
                fluid
                selection
                options={selection.options}
                onChange={this.handleDropdownChange.bind(this)}
            />
            <br />
        </div>
    ));
}


function DropHeader(){
    return (
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>Degerlendirme</Table.HeaderCell>
                <Table.HeaderCell>Egitim Durumu</Table.HeaderCell>
                <Table.HeaderCell>Duzelt</Table.HeaderCell>
                <Table.HeaderCell>Devam Et</Table.HeaderCell>
            </Table.Row>
        </Table.Header>);
}
function DropElements(s) {
    return s.map((selection, index) => (
        <Table.Row>
            <Table.Cell>{selection.degerlendirme}</Table.Cell>
            <Table.Cell>
                <Dropdown
                    placeholder='Seciniz'
                    id={`d${index+1}`}
                    fluid
                    selection
                    options={selection.options}
                    onChange={this.handleInfo.bind(this)}
                />
            </Table.Cell>
            <Table.Cell style={{ width: '30%' }}>
                <MultiDropdown
                    options={selection.duzelt}
                    name='Duzelt'
                />
            </Table.Cell>
            <Table.Cell style={{ width: '30%'}}>
                <MultiDropdown
                    options={selection.devam}
                    name='Devam Et'
                />
            </Table.Cell>
        </Table.Row>
    ));
}

export function certificate1(selection) {
    return (
        <div>
            <div>
                <div>  
                    <div id = 'Egitimler-1'>
                        <span id='items'>Degerlendirme Tarihi</span>
                        {datePicker.bind(this)('Egitimler')}
                    </div>
                </div>
                <div>
                    <br />
                    {
                        Selections2.map((s)=>(
                            <span>
                                <span id='items'>{s.label}:</span>
                                <Input type="text" placeholder={s.label} id={s.id} onChange={this.handleChange.bind(this)} />
                                <br />
                            </span>
                        ))
                    }
                    {
                        this.props.certificateType === 'DSTAv' &&
                        <span>
                            <span id='items'>Mes.Yet.Bel:</span>
                            <Input type="text" placeholder='SRC: ' id='compCert' onChange={this.handleChange.bind(this)} />
                            <br />
                            <span id='items'>Kacinci Egitim:</span>
                            <Input type="text" id='nofCerts' onChange={this.handleChange.bind(this)} />
                            <br />
                        </span>
                    }
                   
                </div>
                <Divider />
                {drop.bind(this)(selection)}
            </div>
            <br />
            <Button onClick={this.onSubmit} id='Egitimler'>Devam</Button> 
        </div>
    );
}

export function certificate2() {
    let certificateType = this.props.certificateType;
    let selection= [];
    if(certificateType ==='Anti Skid'){
        selection = AntiSkidSelections;
    }
    else if(certificateType === 'Off Road'){
        selection = offRoadSelections;
    }
    else if( certificateType === 'DSTAv' || certificateType === 'DSTOto'){
        selection = DSTSelections;
    }
    else selection = AntiSkidSelections;
    return (
        <div>
            <Table id='antiSkid' textAlign='center' style={{ background: 'rgba(255,255,255,0.12)' }}>
                {DropHeader.bind(this)()}
                <Table.Body>
                    {DropElements.bind(this)(selection)}  
                    <Table.Row>
                        <Table.Cell></Table.Cell>
                        <Table.Cell></Table.Cell>
                        <Table.Cell>Guvenli Surus Toplam Puan:</Table.Cell>
                        <Table.Cell>{this.totalInfo()}</Table.Cell>
                    </Table.Row>
                </Table.Body> 
            </Table>
            <Button id='Egitimler' onClick={this.submitCertificate}>Gonder</Button> 
            
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/PanelPages/EgitimTabs.jsx